import { createContext, useContext } from 'react';
import type SelectStore from '../../../../domain/select_store';
import type SelectRepository from '../../../../domain/select_repository';
import type SearchQuery from '../../../../domain/search_query';
import type { SelectType } from '../../../../domain/select_store';

// TODO: dir構造がcomponents群と混在しているので最適な場所に整理する必要がある
interface SelectContextValue {
  store: SelectStore;
  repository: SelectRepository;
  query: SearchQuery;

  submitting: boolean;
  selectErrors: string[];

  handleNextButtonClick: (e: React.MouseEvent<HTMLElement>) => void;
  handleSelectType: (type: SelectType) => () => void;
}

const SelectContext = createContext<SelectContextValue | undefined>(undefined);

export const useSelectContext = () => {
  const context = useContext(SelectContext);
  if (!context) {
    throw new Error('useSelectContext must be used within SelectProvider');
  }
  return context;
};

export { SelectContext };
export type { SelectContextValue };
